import HowItWorks from ".";

export const howitworksRoutes = () => [
  {
    path: "/admin/how-it-works",
    title: "How It Works",
    layout: "admin",
    routeType: "admin",
    component: HowItWorks,
  },
];
